import React, { useRef, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import styled from 'styled-components/macro';
import { useGetSearchResultsForMultipleQuery } from '../../graphql/search.generated';
import { EntityType } from '../../types.generated';
import { SearchBar } from '../search/SearchBar';
import ClickOutside from '../shared/ClickOutside';
import { useEntityRegistry } from '../useEntityRegistry';
import DomainSearchResultItem from './DomainSearchResultItem';
import { useTranslation } from '../../i18n/useTranslation';

const DomainSearchWrapper = styled.div`
    position: relative;
`;

const ResultsWrapper = styled.div`
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
    max-height: 380px;
    overflow: auto;
    padding: 8px;
    position: absolute;
    max-height: 210px;
    overflow: auto;
    width: calc(100% - 24px);
    left: 12px;
    top: 45px;
    z-index: 1;
`;

function DomainSearch() {
    const [query, setQuery] = useState('');
    const [isSearchBarFocused, setIsSearchBarFocused] = useState(false);
    const entityRegistry = useEntityRegistry();
    const { t } = useTranslation();
    const { data, loading } = useGetSearchResultsForMultipleQuery({
        variables: {
            input: {
                types: [EntityType.Domain],
                query,
                start: 0,
                count: 50,
            },
        },
    });

    const searchResults = data?.searchAcrossEntities?.searchResults;
    const timerRef = useRef(-1);

    const handleQueryChange = (q: string) => {
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => {
            setQuery(q);
        }, 250);
    };

    const renderSearchResults = () => (
        <ResultsWrapper>
            {!loading ? (
                searchResults?.map((result) => (
                    <DomainSearchResultItem
                        key={result.entity.urn}
                        entity={result.entity}
                        entityRegistry={entityRegistry}
                        query={query}
                        onResultClick={() => setIsSearchBarFocused(false)}
                    />
                ))
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
                </div>
            )}

            {!searchResults?.length && !loading && <span>{t('NO_RESULTS_FOUND')}</span>}
        </ResultsWrapper>
    );
    return (
        <DomainSearchWrapper>
            <ClickOutside onClickOutside={() => setIsSearchBarFocused(false)}>
                <SearchBar
                    suggestions={[]}
                    className="pa-2"
                    inputSize="middle"
                    hideRecommendations
                    onSearch={() => null}
                    initialQuery={query || ''}
                    entityRegistry={entityRegistry}
                    onQueryChange={(q) => handleQueryChange(q)}
                    onFocus={() => setIsSearchBarFocused(true)}
                    placeholderText={t('SEARCH_DOMAINS_PLACEHOLDER')}
                />
                {isSearchBarFocused && renderSearchResults()}
            </ClickOutside>
        </DomainSearchWrapper>
    );
}

export default DomainSearch;
